import {useStylesECDS} from '../../ward/forms/ecds/ecdsStyle';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {user} from '../../../store/reducers/user';
import moment from 'moment/moment';
import Formatter from '../../../util/formatter';
import React, {Fragment, useEffect, useMemo, useRef, useState} from 'react';
import * as _ from 'lodash';
import uuidv4 from 'uuid/v4';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import InformationBox from '../../../components/other/informationBoxNew';
import Button from '@mui/material/Button';
import {Checkbox, FormLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import AgyleBlockSwitch from '../../../components/ui/switch/agyleBlockSwitch';
import MessageBox from '../../../util/messageBox';
import Typography from '@mui/material/Typography';


const HouseholdComponent = (props) => {
  const classes = useStylesECDS();
  const { t } = useTranslation();
  const userObject = useSelector(user);

  //  For Delete
  const [deleteItem, setDeleteItem] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogHouseholdOpen, setDialogHouseholdOpen] = useState(false);

  const tester = Formatter.formatUserFullName(userObject);

  // Data form
  const [householdComponent, setHouseholdComponent] = useState(props.data);
  const [form, setForm] = useState({
    parentalResponsibility: false,
    name: "",
    age: "",
    relationship: "",
    contact: "",
  });
  const [error, setError] = useState(false);

  const { disabled } = props;

  useEffect(() => {
    const index = props.index;
    let householdComp = _.cloneDeep(householdComponent);
    const newArray = props.householdData;

    if (props.householdData.length > 0) {
      newArray[index] = householdComp;
      props.setData(newArray);
    }
  }, [householdComponent]);

  const deletePeople = () => {
    let householdComp = _.cloneDeep(householdComponent);
    householdComp.householdPeople = householdComp.householdPeople.filter(
      (v) => v.id !== deleteItem.id
    );
    setHouseholdComponent(householdComp);

    setDeleteItem(null);
    setDialogOpen(false);
  };

  const deleteHousehold = () => {
    props.delete(props.id);
    setDeleteItem(null);
    setDialogHouseholdOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((prevState) => ({ ...prevState, [name]: value }));
  };

  const addToTable = () => {
    const error = form.name !== "" && form.relationship !== "";
    if (!error) {
      setError(true);
    } else {
      const dataForm = {
        ...form,
        id: uuidv4() + "",
        date: moment().toISOString(),
        by: tester,
        login: userObject?.userName,
      };

      if (typeof householdComponent.householdPeople === "undefined") {
        setHouseholdComponent((prevState) => ({
          ...prevState,
          householdPeople: [dataForm],
        }));
      } else {
        setHouseholdComponent((prevState) => ({
          ...prevState,
          householdPeople: [...prevState.householdPeople, dataForm],
        }));
      }
      setForm({
        parentalResponsibility: false,
        name: "",
        age: "",
        relationship: "",
        contact: "",
      });
      setError(false);
    }
  };

  const renderTable = useMemo(() => {
    if (householdComponent && householdComponent.householdPeople) {
      return (
        <Fragment>
          <Grid item xs={12}>
            <TableContainer component={Paper} className={classes.table}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">{t("No")}</TableCell>
                    <TableCell>{t("Person Name")}</TableCell>
                    <TableCell align="center">
                      {t("Parental Responsibility")}
                    </TableCell>
                    <TableCell align="right">{t("Age")}</TableCell>
                    <TableCell align="right">{t("Relationship")}</TableCell>
                    <TableCell align="right">{t("Contact Details")}</TableCell>
                    <TableCell align="center">{t("Delete")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {householdComponent.householdPeople.map((row, index) => (
                    <TableRow
                      key={row.id + index}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          checked={row.parentalResponsibility}
                          disabled={true}
                        />
                      </TableCell>
                      <TableCell align="right">{row.age}</TableCell>
                      <TableCell align="right">{row.relationship}</TableCell>
                      <TableCell align="right">{row.contact}</TableCell>
                      <TableCell align="center">
                        <Button
                          disabled={disabled}
                          onClick={() => {
                            setDeleteItem(row);
                            setDialogOpen(true);
                          }}
                        >
                          <DeleteIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Fragment>
      );
    }
  }, [householdComponent, disabled]);

  const renderHousehold = useMemo(() => {
    return (
      <Fragment>
        <Paper className={classes.paper} elevation={3}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <span style={{ margin: "10px" }}>
              {" "}
              {t("Household ")} {props.index + 1}
              <Button
                disabled={disabled}
                onClick={() => {
                  // setDeleteItem(householdComponent);
                  setDeleteItem(householdComponent);
                  setDialogHouseholdOpen(true);
                }}
              >
                <DeleteIcon />
              </Button>
            </span>
          </Grid>

          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={12} md={5}>
              <AgyleTextField
                size={"large"}
                fullWidth
                name="name"
                noBorder={false}
                label={t("Name")}
                className={classes.input}
                onChange={handleChange}
                value={form.name || ""}
                variant="outlined"
                error={error}
                disabled={disabled}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <AgyleTextField
                size={"large"}
                fullWidth
                noBorder={false}
                name="age"
                label={t("Age")}
                className={classes.input}
                onChange={handleChange}
                value={form.age || ""}
                variant="outlined"
                type={"number"}
                inputProps={{ maxLength: 3 }}
                disabled={disabled}
              />
            </Grid>

            <Grid item xs={12} md={5}>
              <AgyleTextField
                size={"large"}
                fullWidth
                noBorder={false}
                name="relationship"
                label={t("Relationship")}
                className={classes.input}
                onChange={handleChange}
                value={form.relationship || ""}
                variant="outlined"
                error={error}
                disabled={disabled}
              />
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid
                  item
                  xs={12}
                  md={4}
                  style={{ display: "flex", maxHeight: "35px" }}
                  sx={{ mb: 1 }}
                >
                  <FormLabel sx={{ ml: 0.5, mr: 3, mt: 0.5 }}>
                    {t("Parental Responsibility")}
                  </FormLabel>
                  <AgyleBlockSwitch
                      disabled={disabled}
                    onChange={(val) =>
                      setForm({ ...form, parentalResponsibility: val })
                    }
                    value={form.parentalResponsibility || false}
                    style={{ marginRight: 10 }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={8}
                  sx={{
                    pl: {
                      xs: 0,
                      md: 1,
                    },
                  }}
                >
                  <AgyleTextField
                    size={"large"}
                    fullWidth
                    noBorder={false}
                    name="contact"
                    label={t("Contact details")}
                    className={classes.input}
                    onChange={handleChange}
                    value={form.contact || ""}
                    variant="outlined"
                    disabled={disabled}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            style={{ marginTop: "10px" }}
          >
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item xs={12}>
                <AgyleTextField
                  size={"large"}
                  fullWidth
                  noBorder={false}
                  name="householdInformation"
                  label={t("Household Additional Information")}
                  className={classes.input}
                  disabled={disabled}
                  onChange={(event) =>
                    setHouseholdComponent((prevState) => ({
                      ...prevState,
                      householdInformation: event.target.value,
                    }))
                  }
                  value={householdComponent.householdInformation || ""}
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Button
                variant="contained"
                onClick={addToTable}
                // disabled={props.disableSave || !dispatch(hasPermission(Permissions.AGYLE_CAN_MANAGE_HOUSEHOLD))}>
                disabled={disabled}
                style={{marginTop: 5, marginLeft: 'auto'}}
            >
              {t("Add")}
            </Button>
            <div style={{ width: "100%" }}>{renderTable}</div>
          </Grid>
        </Paper>
      </Fragment>
    );
  }, [form, householdComponent, error, disabled]);

  return (
    <Fragment>
      {renderHousehold}

      <MessageBox
        onClose={() => setDialogOpen(false)}
        title={t("Confirmation")}
        message={t("Do you really want to remove this item?")}
        haveAccept={{ yes: t("Submit"), no: t("Close") }}
        onAccept={deletePeople}
        open={dialogOpen}
      />

      <MessageBox
        onClose={() => setDialogHouseholdOpen(false)}
        title={t("Confirmation")}
        message={t("Do you really want to remove this whole household?")}
        haveAccept={{ yes: t("Submit"), no: t("Close") }}
        onAccept={deleteHousehold}
        open={dialogHouseholdOpen}
      />
    </Fragment>
  );
};


export default function AdmitHousehold({ admit, setAdmit, checkDisabled, disabled}) {
  const classes = useStylesECDS();
  const { t } = useTranslation();

  const userObject = useSelector(user);
  const timestamp = moment().toISOString();
  const tester = Formatter.formatUserFullName(userObject);
  const [householdData, setHouseholdData] = useState([]);
  const updated = useRef(false);

  useEffect(() => {
    if (!updated.current && !_.isEmpty(admit?.household)) {
      setHouseholdData(admit?.household);
      updated.current = true;
    }
  }, [admit?.household]);

  const addNewHousehold = () => {
    const emptyObj = {
      id: uuidv4() + "",
      householdInformation: "",
      householdPeople: [],
      date: timestamp,
      by: tester,
      login: userObject?.userName,
    };

    setHouseholdData((prevState) => [...prevState, emptyObj]);
  };

  useEffect(() => {
    setAdmit((prevState) => ({
      ...prevState,
      household: householdData,
    }));
  }, [householdData]);

  const deleteHousehold = (id) => {
    setHouseholdData((prevState) => prevState.filter((item) => item.id !== id));
  };

  const renderNewHousehold = (description) => {
    return (
      <Fragment>
        <Paper className={classes.paper} elevation={3}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item xs={8}>
              {description && (
                <h3 className={classes.description}>
                  {t(
                    "No household information was provided, please add a new household"
                  )}
                </h3>
              )}
            </Grid>
          </Grid>
        </Paper>
      </Fragment>
    );
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid item xs={12} sx={{ mx: 2 }}>
        <InformationBox type={"info"}>
          <Typography variant="body1" fontWeight={500}>
            {t("Record the following information")}
          </Typography>
          <ul>
            <li>
              <Typography variant="body1" fontWeight={500}>
              {t(
                "Please state who else lives in the household with the child?"
              )}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" fontWeight={500}>
              {t(
                "Under 18s - Please state Name, Age and relationship to the child."
              )}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" fontWeight={500}>
              {t("Over 18s - Please state Name and relationship to the child.")}
              </Typography>
            </li>
          </ul>
        </InformationBox>
      </Grid>
      <Grid item xs={12}>
        {householdData &&
          householdData.length === 0 &&
          renderNewHousehold(true)}
        {householdData.map((element, index) => {
          return (
            <div key={element.id + index}>
              <HouseholdComponent
                admit={admit}
                setAdmit={setAdmit}
                data={element}
                id={element.id}
                index={index}
                householdData={householdData}
                setData={setHouseholdData}
                delete={deleteHousehold}
                disabled={disabled}
              />
            </div>
          );
        })}
        {householdData &&
          householdData.length !== 0 &&
          renderNewHousehold(false)}

        <Button
          variant="contained"
          style={{ margin: "10px", width: "auto", float: "right" }}
          disabled={checkDisabled()}
          onClick={addNewHousehold}
        >
          {t("Add New Household")}
        </Button>
      </Grid>
    </Grid>
  );
};